import { ColumnConfig } from '../hooks/useTablePreferences';

export const serviceColumns: ColumnConfig[] = [
  {
    key: 'name',
    label: 'Name',
    defaultWidth: 220,
    minWidth: 160,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'medicationType',
    label: 'Medication Type',
    defaultWidth: 150,
    minWidth: 120,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'meetingFlow',
    label: 'Meeting Flow',
    defaultWidth: 420,
    minWidth: 200,
    visible: true,
    sortable: false,
    resizable: true,
    draggable: true,
  },
];
